import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button } from "@/components/Buttons";
import ErrorMessage from "@/components/Form/Parts/ErrorMessage";
import { HiddenField } from "@/components/Form/Parts/index";
import { usePaymentMethodsQuery, useRecaptchaV3 } from "@/hooks";
import { PAYMENT_METHOD_ID, errorMessages } from "@/lib/constants";
import routes from "@/lib/routes";
import yupCreditCardNumberValidate from "@/lib/yupCreditCardNumberValidate";
import yupExpirationDateValidate from "@/lib/yupExpirationDateValidate";
import formStyles from "@/styles/Form.module.scss";
import paymentSelectStyles from "@/styles/PaymentSelect.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import Link from "next/link";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import * as y from "yup";
import CreditCardInput from "./CreditCardInput";
import PaymentInstruments from "./PaymentInstruments";
import PaymentMethods from "./PaymentMethods";
import RecaptchaV2 from "./RecaptchaV2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
yupExpirationDateValidate(y);
yupCreditCardNumberValidate(y);
export var CREATE_ONLY_MODE = ["addpayment"];
export var PURCHASE_MODE = ["svod", "tvod"];
export var IGNORE_PAYPAY = ["svod", "changesvod"];
export default function PaymentSelectForm(_ref) {
  var mode = _ref.mode,
      onSubmit = _ref.onSubmit,
      paymentText = _ref.paymentText,
      registerPaymentText = _ref.registerPaymentText,
      error = _ref.error,
      clearError = _ref.clearError,
      recaptchaSuccessV3 = _ref.recaptchaSuccessV3,
      recaptchaCounterV2 = _ref.recaptchaCounterV2;

  var _useState = useState(false),
      disableSubmitWithRecaptcha = _useState[0],
      setDisableSubmitWithRecaptcha = _useState[1];

  var _useState2 = useState(),
      recaptchaTokenV2 = _useState2[0],
      setRecaptchaTokenV2 = _useState2[1];

  var _useRecaptchaV = useRecaptchaV3(),
      showRecaptchaV3Badge = _useRecaptchaV.showRecaptchaV3Badge,
      hideRecaptchaV3Badge = _useRecaptchaV.hideRecaptchaV3Badge; // recaptchaバッジの表示制御


  useEffect(function () {
    showRecaptchaV3Badge();
    return function () {
      hideRecaptchaV3Badge();
    };
  }, []);

  var _useState3 = useState({
    showInput: false,
    ccInputError: false,
    paymentMethod: "",
    createPayment: CREATE_ONLY_MODE.includes(mode)
  }),
      state = _useState3[0],
      setState = _useState3[1];

  var showInput = state.showInput,
      paymentMethod = state.paymentMethod,
      createPayment = state.createPayment;
  useEffect(function () {
    // 支払い方法にクレジットカード選択かつ、reCAPTCHAv3が失敗したかつ、recaptchaTokenV2が未生成の場合は送信ボタンを無効化
    if (showInput && recaptchaSuccessV3 === false && !recaptchaTokenV2) {
      setDisableSubmitWithRecaptcha(true);
    } else {
      setDisableSubmitWithRecaptcha(false);
    }
  }, [recaptchaTokenV2, recaptchaSuccessV3, showInput]);
  var schema = useMemo(function () {
    var withCreditCardSchema = {
      cardNumber: y.string().creditCardNumber().required("カード番号を入力してください。"),
      expirationDate: y.string().min(6, "有効期限を選択してください。").expirationDate().required("有効期限を選択してください。"),
      cvv: y.string().min(3, "3桁または4桁で入力してください。").max(4, "3桁または4桁で入力してください。").required("セキュリティコードを入力してください。")
    };
    var baseSchema = {
      paymentMethod: y.number().required("選択してください。"),
      paymentInstrument: y.number(),
      createPayment: y.boolean()
    };

    var schema = function () {
      if (createPayment && paymentMethod === PAYMENT_METHOD_ID.CREDIT_CARD) {
        return _objectSpread(_objectSpread({}, baseSchema), withCreditCardSchema);
      } else {
        return baseSchema;
      }
    }();

    return y.object().shape(schema);
  }, [createPayment, paymentMethod]);

  var _useForm = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.errors,
      formState = _useForm.formState,
      setValue = _useForm.setValue;

  useEffect(function () {
    register({
      name: "recaptchaType"
    });
    register({
      name: "recaptchaToken"
    });
  }, []);
  useEffect(function () {
    if (recaptchaSuccessV3 === true) {
      setValue("recaptchaType", "v3");
    } else if (recaptchaSuccessV3 === false) {
      setValue("recaptchaType", "v2");
    } else {
      setValue("recaptchaType", "v3");
    }
  }, [recaptchaSuccessV3]);
  var isDirty = formState.isDirty,
      isValid = formState.isValid,
      isSubmitting = formState.isSubmitting;

  var _usePaymentMethodsQue = usePaymentMethodsQuery(),
      data = _usePaymentMethodsQue.data,
      loading = _usePaymentMethodsQue.loading;

  var paymentMethods = data === null || data === void 0 ? void 0 : data.paymentMethods;
  var paymentInstrumentData = data === null || data === void 0 ? void 0 : data.paymentInstruments;
  var onPaymentMethodChange = useCallback(function (newState) {
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), newState);
    });
    if (clearError) clearError();
  }, [clearError]);
  if (loading) return null;
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    children: [/*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [/*#__PURE__*/_jsx("h3", {
          className: "".concat(processStyles.contentHeader, " ").concat(processStyles.required),
          children: "\u304A\u652F\u6255\u3044\u65B9\u6CD5"
        }), /*#__PURE__*/_jsx(PaymentInstruments, {
          mode: mode,
          paymentInstruments: paymentInstrumentData,
          register: register,
          onChange: onPaymentMethodChange
        }), /*#__PURE__*/_jsx(PaymentMethods, {
          mode: mode,
          paymentMethods: paymentMethods,
          paymentInstruments: paymentInstrumentData,
          register: register,
          onChange: onPaymentMethodChange
        }), /*#__PURE__*/_jsx(CreditCardInput, {
          register: register,
          errors: errors,
          setValue: setValue,
          visible: showInput
        }), /*#__PURE__*/_jsx(HiddenField, {
          ref: register,
          name: "createPayment",
          value: createPayment
        }), error && error !== errorMessages["recaptcha"] && /*#__PURE__*/_jsx("div", {
          className: paymentSelectStyles.error,
          children: /*#__PURE__*/_jsx(ErrorMessage, {
            msg: error
          })
        })]
      })
    }), PURCHASE_MODE.includes(mode) && /*#__PURE__*/_jsx("div", {
      className: formStyles.guideArea,
      children: /*#__PURE__*/_jsxs("p", {
        children: ["\u203B\u7279\u5B9A\u5546\u53D6\u5F15\u6CD5\u306B\u3064\u3044\u3066", /*#__PURE__*/_jsx(Link, {
          href: routes.legalSctLaw,
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            className: formStyles.textLink,
            children: "\u3053\u3061\u3089"
          })
        }), "\u304B\u3089\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: formStyles.btnArea,
      children: [error && error === errorMessages["recaptcha"] && !recaptchaTokenV2 && /*#__PURE__*/_jsx("div", {
        className: paymentSelectStyles.error,
        children: /*#__PURE__*/_jsx(ErrorMessage, {
          msg: error
        })
      }), recaptchaSuccessV3 === false && /*#__PURE__*/_jsx(RecaptchaV2, {
        visible: showInput,
        setValue: setValue,
        setRecaptchaTokenV2: setRecaptchaTokenV2,
        recaptchaCounterV2: recaptchaCounterV2
      }), /*#__PURE__*/_jsxs(Button, {
        type: "submit",
        fillColor: true,
        large: true,
        fontFixed: true,
        disabled: !isValid || !isDirty || disableSubmitWithRecaptcha,
        loading: isSubmitting,
        children: [!createPayment && /*#__PURE__*/_jsx(_Fragment, {
          children: paymentText
        }), createPayment && /*#__PURE__*/_jsx(_Fragment, {
          children: registerPaymentText || paymentText
        })]
      })]
    })]
  });
}